import React from "react";

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import PartnerList from "Components/Partners/PartnerList/PartnerList";

const Partners = () => {
  const eventId = localStorage.getItem("eventId");

  return (
    <>
      <Header moduleName={"partners"} />
      <section className="inner_sec">
        <div className="container">
          <div className="page_heading mb-5">
            <h1 className="position-relative pb-4 text-uppercase">Partners</h1>
          </div>
          <PartnerList eventId={eventId} />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Partners;
